<template>
    <v-card class="p-3">
        <div class="d-flex justify-content-between">
            <h5>Commentaires / Appels</h5>

            <div class="d-flex justify-content-between gap-10">
                <v-btn outlined class="custom-button-primary"
                       :disabled="emptyComment !== null || emptyPhoneCall !== null" @click="addEmptyComment"
                       style="height: 36px;min-width: 42px;padding: 0">
                    <v-icon>add_comment</v-icon>
                </v-btn>

                <v-btn outlined class="custom-button-primary"
                       :disabled="emptyComment !== null || emptyPhoneCall !== null" @click="addEmptyPhoneCall"
                       style="height: 36px;min-width: 42px;padding: 0">
                    <v-icon>add_ic_call</v-icon>
                </v-btn>
            </div>
        </div>

        <v-timeline align-top dense v-if="emptyComment !== null">
            <v-timeline-item icon="comment" fill-dot color="">
                <v-textarea outlined label="Commentaire" auto-grow v-model="emptyComment.content" hide-details>
                </v-textarea>

                <div class="d-flex justify-content-end gap-10 mt-3">
                    <v-btn outlined small @click="emptyComment = null">
                        Annuler
                    </v-btn>

                    <v-btn outlined class="custom-button-primary" small @click="addComment"
                           :disabled="emptyComment.content === null || emptyComment.content === ''">
                        <v-icon left>mdi-plus</v-icon>
                        Ajouter
                    </v-btn>
                </div>
            </v-timeline-item>
        </v-timeline>

        <v-timeline align-top dense v-if="emptyPhoneCall !== null">
            <v-timeline-item icon="phone" fill-dot color="">
                <v-textarea outlined label="Notes de l'appel" auto-grow v-model="emptyPhoneCall.content" hide-details>
                </v-textarea>

                <div class="w-100 mt-3">
                    <v-label>Date de l'appel</v-label>

                    <div class="d-flex justify-content-between">
                        <input type="date" id="meeting-date" v-model="emptyPhoneCall.date" class="mr-2">
                        <input type="time" id="meeting-time" v-model="emptyPhoneCall.time" class="ml-2">
                    </div>
                </div>

                <div class="d-flex justify-content-end gap-10 mt-3">
                    <v-btn outlined small @click="emptyPhoneCall = null">
                        Annuler
                    </v-btn>

                    <v-btn outlined class="custom-button-primary" small @click="addPhoneCall"
                           :disabled="emptyPhoneCall.content === null || emptyPhoneCall.content === ''">
                        <v-icon left>mdi-plus</v-icon>
                        Ajouter
                    </v-btn>
                </div>
            </v-timeline-item>
        </v-timeline>

        <v-timeline align-top dense v-if="phoneAndComments.length">
            <v-timeline-item :icon="getPhoneCommentTimelineIcon(item)"
                             v-for="item in phoneAndComments"
                             fill-dot
                             :key="item.id"
                             color="">
                <div v-if="selectedPhoneOrComment !== null &&
                selectedPhoneOrComment.id === item.id &&
                selectedPhoneOrComment.type === item.type">
                    <v-textarea outlined auto-grow hide-details v-model="selectedPhoneOrComment.content">
                    </v-textarea>

                    <div v-if="item.phoned_at !== undefined" class="mt-2">
                        <v-label>Date de l'appel</v-label>

                        <div class="d-flex justify-content-between">
                            <input type="date" id="meeting-date" v-model="selectedPhoneOrComment.date" class="mr-2">
                            <input type="time" id="meeting-time" v-model="selectedPhoneOrComment.time" class="ml-2">
                        </div>
                    </div>
                </div>
                <div class="phone-comment-item" v-else>
                    <div>{{ item.content }}</div>
                </div>

                <div v-if="selectedPhoneOrComment !== null &&
                selectedPhoneOrComment.id === item.id &&
                selectedPhoneOrComment.type === item.type">
                    <div class="d-flex justify-content-end gap-10 mt-3">
                        <v-btn outlined small @click="selectedPhoneOrComment = null">
                            Annuler
                        </v-btn>

                        <v-btn outlined class="custom-button-primary" small @click="updatePhoneCall"
                               v-if="selectedPhoneOrComment.phoned_at !== undefined" :disabled="selectedPhoneOrComment.content === null ||
                            selectedPhoneOrComment.content === ''">
                            Modifier
                        </v-btn>
                        <v-btn outlined class="custom-button-primary" small v-else @click="updateComment" :disabled="selectedPhoneOrComment.content === null ||
                        selectedPhoneOrComment.content === ''">
                            Modifier
                        </v-btn>
                    </div>
                </div>

                <div class="d-flex justify-content-between" v-else>
                    <div>
                        <div class="phone-comment-info mt-auto mb-auto">
                            {{ formatDate(item.timed_at) }} par {{ item.user.first_name }} {{ item.user.last_name }}
                        </div>
                    </div>

                    <div v-if="user.id === item.user.id">
                        <v-btn icon @click="selectPhoneOrComment(item)" class="custom-button-primary" small>
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn icon v-if="item.phoned_at !== undefined" class="custom-button-error"
                               @click="deletePhoneCall(item.id)" small>
                            <v-icon>delete</v-icon>
                        </v-btn>
                        <v-btn icon v-else class="custom-button-error" @click="deleteComment(item.id)" small>
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </div>
                </div>
            </v-timeline-item>
        </v-timeline>

        <div class="text-center" v-if="phoneAndComments.length == 0">
            <small>
                Aucun appel ou commentaire
            </small>
        </div>

        <confirm ref="confirm"></confirm>
    </v-card>
</template>

<script>
import { mapState } from "vuex"
import Confirm from "../tools/Confirm.vue"

export default {
    name: "EntityPhoneCallsBloc",
    components: { Confirm },
    props: ['entityId'],
    data() {
        return {
            openedCommentOrPhoneCallDialog: false,
            noteTypes: [
                { code: 'COMMENT', label: 'Commentaire' },
                { code: 'PHONE_CALL', label: 'Appel téléphonique' }
            ],
            emptyComment: null,
            emptyPhoneCall: null,
            phoneAndComments: [],
            selectedPhoneOrComment: null
        }
    },
    methods: {
        getPhonesAndComments() {
            this.$http.get('auth/sit-entity/' + this.entityId + '/phones-and-comments').then(res => {
                this.phoneAndComments = res.body.data.phoneAndComments
            })
        },
        addEmptyComment() {
            this.selectedPhoneOrComment = null

            this.emptyComment = { content: null }
        },
        addEmptyPhoneCall() {
            this.selectedPhoneOrComment = null

            let date = this.$moment().format('YYYY-MM-DD')
            let time = this.$moment().format('HH:mm')

            this.emptyPhoneCall = { content: null, date: date, time: time }
        },
        addPhoneCall() {
            let dateTime = this.emptyPhoneCall.date

            dateTime += ' ' + this.emptyPhoneCall.time

            let payload = {
                entityId: this.entityId,
                value: this.emptyPhoneCall.content,
                phonedAt: dateTime
            }

            this.$http.post('auth/sit-entity/phone-call', payload).then(res => {
                this.getPhonesAndComments()

                this.emptyPhoneCall = null
            })
        },
        addComment() {
            let payload = {
                entityId: this.entityId,
                value: this.emptyComment.content
            }

            this.$http.post('auth/sit-entity/comment', payload).then(res => {
                this.getPhonesAndComments()

                this.emptyComment = null
            })
        },
        getPhoneCommentTimelineIcon(item) {
            return item.phoned_at !== undefined ? 'phone' : 'comment'
        },
        deleteComment(id) {
            this.$refs.confirm.open('Suppression du commentaire',
              'Êtes-vous sûr de vouloir supprimer le commentaire ?',
              { color: 'error', cancelColor: '#0b697e', confirmColor: 'error' }).
            then((confirm) => {
                if (confirm) {
                    this.$http.delete('auth/sit-entity/comment/' + id).then(res => {
                        this.getPhonesAndComments()
                    })
                }
            })
        },
        deletePhoneCall(id) {
            this.$refs.confirm.open('Suppression du commentaire',
              'Êtes-vous sûr de vouloir supprimer l\'appel téléphonique ?',
              { color: 'red', cancelColor: '#0b697e', confirmColor: 'red' }).
            then((confirm) => {
                if (confirm) {
                    this.$http.delete('auth/sit-entity/phone-call/' + id).then(res => {
                        this.getPhonesAndComments()
                    })
                }
            })
        },
        selectPhoneOrComment(item) {
            this.emptyComment = null
            this.emptyPhoneCall = null

            this.selectedPhoneOrComment = JSON.parse(JSON.stringify(item))
        },
        updatePhoneCall() {
            let dateTime = this.selectedPhoneOrComment.date

            dateTime += ' ' + this.selectedPhoneOrComment.time

            let payload = {
                id: this.selectedPhoneOrComment.id,
                value: this.selectedPhoneOrComment.content,
                phonedAt: dateTime
            }

            this.$http.put('auth/sit-entity/update-phone-call', payload).then(res => {
                this.getPhonesAndComments()

                this.selectedPhoneOrComment = null
            })
        },
        updateComment() {
            let payload = {
                id: this.selectedPhoneOrComment.id,
                value: this.selectedPhoneOrComment.content
            }

            this.$http.put('auth/sit-entity/update-comment', payload).then(res => {
                this.getPhonesAndComments()

                this.selectedPhoneOrComment = null
            })
        }
    },
    computed: {
        ...mapState('account', ['user'])
    },
    created() {
        this.getPhonesAndComments()
    }
}
</script>